import React from 'react';
import { useSelector } from 'react-redux';
import { Divider } from 'components/common_v2/layouts';
import { Box, Drawer, IconButton } from '@mui/material';
import { isDesktop, isMobile } from 'react-device-detect';
import { makeStyles } from '@mui/styles';
import { getUser, getUserAuthentication } from 'selectors';
import { serializeClasses } from 'utilities/css';
import { NavBarList } from './components';
import {
  HomeLink,
  LogoutLink,
  ManagementLinks,
  MessagesLink,
  PostJobLink,
  ReportsLink,
  SettingsLink,
  SupportLink,
} from './sections';
import { MenuIcon } from '../../common_v2/icons';

const DRAWER_WIDTH = 216;

const mobileConfig = (open, onClose) => ({
  variant: 'temporary',
  open,
  onClose,
  ModalProps: {
    keepMounted: true, // Improves performance on mobile
  },
});

const desktopConfig = {
  variant: 'permanent',
  open: true,
};

const useStyles = makeStyles(() => ({
  root: {
    minWidth: DRAWER_WIDTH,
    flexShrink: 0,
    position: 'initial',
    top: 'auto',
    left: 'auto',
    zIndex: 899,
    boxSizing: 'border-box',

    '&.mobile': {
      position: 'absolute',
      top: '0',
      left: '0',
      zIndex: 1299,
    },
  },
  drawerPaper: {
    boxSizing: 'border-box',
    top: '40px',
    height: 'calc(100% - 40px)'
  },
}));

const NavigationBar = () => {
  const authenticated = useSelector(getUserAuthentication);
  const { canPostJobs } = useSelector(getUser);

  if (authenticated) {
    return (
      <NavBarList>
        <HomeLink />
        {canPostJobs && <PostJobLink />}
        <ManagementLinks />
        <MessagesLink />
        <Divider className="horizontal" />
        <ReportsLink />
        <SupportLink />
        <SettingsLink />
        <Divider className="horizontal" />
        <LogoutLink />
      </NavBarList>
    );
  }
  return null;
};

export const ResponsiveNavigationBar = (props) => {
  const styleClasses = useStyles();
  const authenticated = useSelector(getUserAuthentication);
  const classes = serializeClasses([isMobile && 'mobile', styleClasses.root]);
  const [isOpen, setIsOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    if (isDesktop) return; // Prevent closing on desktop
    setIsOpen(!isOpen);
  };

  if (!authenticated) {
    return null;
  }

  return (
    <Box component="nav" className={classes} aria-label="navigation">
      {isMobile && (
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ margin: '0 4px' }}
        >
          <MenuIcon />
        </IconButton>
      )}
      <Drawer
        classes={{ paper: styleClasses.drawerPaper }}
        {...(isMobile ? mobileConfig(isOpen, handleDrawerToggle) : desktopConfig)}
      >
        <NavigationBar {...props} />
      </Drawer>
    </Box>
  );
};
